import { cn } from "@/lib/utils";

export function StatusBadge({ status }) {
  // Pawkt semantic tones — success(green), warning(butter), danger(coral), info(sky), primary(lavender), neutral(elevated)
  const SUCCESS = "bg-pawkt-mint text-pawkt-success-deep border-transparent";
  const WARNING = "bg-pawkt-butter text-pawkt-secondary-deep border-transparent";
  const DANGER = "bg-pawkt-coral text-pawkt-emergency border-transparent";
  const INFO = "bg-[#EAEFFB] text-[#4C68B5] border-transparent";
  const PRIMARY = "bg-pawkt-primary-soft text-pawkt-primary-deep border-transparent";
  const NEUTRAL = "bg-pawkt-elevated text-pawkt-text-secondary border-transparent";
  const map = {
    confirmed: SUCCESS, completed: SUCCESS, paid: SUCCESS, won: SUCCESS, active: SUCCESS,
    pending: WARNING, partially_paid: WARNING, partial: WARNING,
    unpaid: NEUTRAL, draft: NEUTRAL,
    in_progress: INFO, consultation: INFO, contacted: INFO,
    qualified: PRIMARY, proposal: PRIMARY,
    new: PRIMARY,
    cancelled: DANGER, no_show: DANGER, failed: DANGER, refunded: DANGER, lost: DANGER,
    vip: PRIMARY,
  };
  const label = (status || "").replace(/_/g, " ");
  return (
    <span
      data-testid={`status-${status}`}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold capitalize",
        map[status] || NEUTRAL
      )}
    >
      {label}
    </span>
  );
}
